import { navigatorClient } from "@/api";
import type { ApiResponse } from "@/types";

// F00 HOME (backend /home). 주목받는 에이전트는 finder-service의 getTrending을 같이 써요.

export interface HomeAgentRow {
  id: string;
  name: string;
  supplier_name: string | null;
  logo_url: string | null;
  is_certified: boolean;
  detail_type: "external" | "internal";
  // △(비회원 · 승인 대기 · 공급자): 한 줄 소개 · 숫자 없이 와요 (화면 Blur)
  locked: boolean;
  summary?: string | null;
}

export interface CertifiedResult {
  items: (HomeAgentRow & { adoption_count?: number })[];
  total: number;
  locked: boolean;
}

export interface IndustryTopResult {
  industry: string | null;
  label: string | null;
  tabs: { code: string; label: string }[];
  items: (HomeAgentRow & { rank: number; view_count?: number; inquiry_count?: number })[];
  locked: boolean;
}

export async function getCertified(signal?: AbortSignal) {
  const { data } = await navigatorClient.get<ApiResponse<CertifiedResult>>("/home/certified", { signal });
  return data.data!;
}

export async function getIndustryTop(industry?: string, signal?: AbortSignal) {
  const { data } = await navigatorClient.get<ApiResponse<IndustryTopResult>>("/home/industry-top", { params: industry ? { industry } : undefined, signal });
  return data.data!;
}

export async function getSearchSuggestions(signal?: AbortSignal) {
  const { data } = await navigatorClient.get<ApiResponse<{ items: string[]; from_logs: number }>>("/home/search-suggestions", { signal });
  return data.data!;
}
